import React, { useState } from 'react'
import { Box, Image, SxStyleProp } from 'rebass'
import { TextV2 as Text } from '../Text/TextV2'
import { containerStyles, getFontStyles, getListItemImageStyles } from './IconLinkList.styles'

export interface IIconLinkProps {
  src: string
  alt: string
  text?: string
  sx?: SxStyleProp
}

export interface IIconLinkListProps {
  items: IIconLinkProps[]
}

export const IconLinkList = ({ items }: IIconLinkListProps) => {
  const [activeIndex, setActiveIndex] = useState(0)

  return (
    <Box sx={containerStyles}>
      {items.map((icon, index) => (
        <Box
          key={`iconLinkItem-${index}`}
          sx={{ display: 'flex', flexDirection: 'column', cursor: 'default' }}
          onMouseEnter={() => setActiveIndex(index)}
        >
          <Image
            src={icon.src}
            alt={icon.alt}
            sx={{ ...getListItemImageStyles(index === activeIndex), ...(icon.sx || {}) }}
          />
          <Box
            data-content={icon.text}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '12px',
              ...getFontStyles(index === activeIndex),
            }}
          >
            <Text>{icon.text}</Text>
          </Box>
        </Box>
      ))}
    </Box>
  )
}
